import React, { useState, useRef, useEffect } from 'react';
import '../css/otp-input.css'; // Thêm dòng này

const OTPInput = ({ onChangePass, onSubmitOTP }) => {
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [isVerifying, setIsVerifying] = useState(false);
  const [countdown, setCountdown] = useState(10 * 60);
  const [canResend, setCanResend] = useState(false);

  const inputRefs = useRef(Array.from({ length: 6 }, () => React.createRef()));

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      setCanResend(true);
    }
  }, [countdown]);

  const handleInput = (index, e) => {
    let char = e.target.value.replace(/\D/g, '').slice(0, 1);

    // Nếu ô đang có giá trị và user lại gõ → XÓA GIÁ TRỊ
    if (otp[index] !== '' && char !== '') {
      const newOtp = [...otp];
      newOtp[index] = '';
      setOtp(newOtp);
      e.target.value = ''; // clear DOM
      return;
    }

    // Ngược lại: gõ lần đầu → nhận ký tự
    const newOtp = [...otp];
    newOtp[index] = char;
    setOtp(newOtp);

    // Auto focus qua ô tiếp theo
    // if (char && inputRefs.current[index + 1]) {
    //   inputRefs.current[index + 1].current.focus();
    // }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace') {
      e.preventDefault(); // Ngăn hành vi mặc định (xóa tự động)

      const newOtp = [...otp];

      if (otp[index]) {
        // Nếu ô hiện tại có số → xóa nó
        newOtp[index] = '';
        setOtp(newOtp);
      } else if (index > 0) {
        // Nếu ô trống → quay lại ô trước
        inputRefs.current[index - 1]?.current?.focus();

        newOtp[index - 1] = '';
        setOtp(newOtp);
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteArray = e.clipboardData.getData('text').split('').slice(0, 6);
    const newOtp = [...otp];
    pasteArray.forEach((char, index) => {
      if (index < 6 && !isNaN(char)) newOtp[index] = char;
    });
    setOtp(newOtp);
    const lastIndex = Math.min(pasteArray.length - 1, 5);
    inputRefs.current[lastIndex].focus();
  };

  const handleVerify = async () => {
    if (otp.every((digit) => digit !== '')) {
      setIsVerifying(true);
      await new Promise((resolve) => setTimeout(resolve, 2000));
      setIsVerifying(false);
      const code = otp.join('');
      onSubmitOTP?.(code);
      onChangePass();
    }
  };

  const handleResend = () => {
    setCountdown(10 * 60);
    setCanResend(false);
    setOtp(['', '', '', '', '', '']);
    inputRefs.current[0].focus();
  };

  const isComplete = otp.every((digit) => digit !== '');

  console.log(otp);

  return (
    <div className="otp-wrapper">
      <div className="otp-input-group">
        {otp.map((digit, index) => (
          <input
            key={index}
            ref={inputRefs.current[index]}
            type="text"
            inputMode="numeric"
            pattern="\d*"
            value={digit}
            onChange={(e) => handleInput(index, e)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            onPaste={handlePaste}
            className={`otp-input ${digit ? 'filled' : ''}`}
          />
        ))}
      </div>
      <button
        onClick={handleVerify}
        disabled={!isComplete || isVerifying}
        className={`otp-verify-btn ${
          isComplete && !isVerifying ? 'active' : 'disabled'
        }`}
      >
        {isVerifying ? 'Đang xác thực...' : 'Xác thực'}
      </button>
      <div className="otp-resend">
        <p>Không nhận được mã?</p>
        {canResend ? (
          <button onClick={handleResend} className="resend-btn">
            Gửi lại mã OTP
          </button>
        ) : (
          <p>
            Gửi lại sau{' '}
            <strong>
              {Math.floor(countdown / 60)}:
              {(countdown % 60).toString().padStart(2, '0')}
            </strong>
          </p>
        )}
      </div>

      {/* <div className="otp-progress">
        <div className="progress-labels">
          <span>Tiến độ</span>
          <span>{otp.filter((digit) => digit !== '').length}/6</span>
        </div>
        <div className="progress-bar">
          <div
            className="progress-fill"
            style={{
              width: `${
                (otp.filter((digit) => digit !== '').length / 6) * 100
              }%`,
            }}
          ></div>
        </div>
      </div> */}

      <div className="otp-help">
        <p>
          <strong>Mẹo:</strong>
        </p>
        <ul>
          <li>• Bạn có thể dán mã OTP trực tiếp vào ô đầu tiên</li>
          <li>• Sử dụng phím Backspace để quay lại ô trước</li>
          <li>• Mã OTP có hiệu lực trong 10 phút</li>
        </ul>
      </div>
    </div>
  );
};

export default React.memo(OTPInput);
